import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { openNewTab } from 'util/helpers';
import { useRouter } from 'next/router';
import styles from './nav-link.module.css';
import type { TagType } from 'antd';

type Props = {
  text: string;
  url: string;
  external?: boolean;
  tag?: React.ReactElement<TagType>;
};

export const NavLink: React.FC<Props> = ({
  text,
  url,
  external = false,
  tag,
}) => {
  const [isCurrentPage, setIsCurrentPage] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (!external) {
      if (router.pathname === url) {
        setIsCurrentPage(true);
      } else {
        setIsCurrentPage(false);
      }
    }
  }, [router.pathname]);

  return external ? (
    <div className={styles.root} onClick={() => openNewTab(url)}>
      <span className={styles.link}>{text}</span>
      {tag && <div className={styles.tagWrapper}>{tag}</div>}
    </div>
  ) : (
    <div className={styles.root}>
      <Link
        href={url}
        className={isCurrentPage ? styles.currentPageLink : styles.link}
      >
        <span className={styles.mobileLinks}>{text}</span>
      </Link>
      {tag && <div className={styles.tagWrapper}>{tag}</div>}
    </div>
  );
};
